// ----------------------------------------------------------------------

import { alpha } from "@mui/material";

export default function Button(theme) {
  return {
    MuiButton: {
      styleOverrides: {
        root: ({ ownerState, theme }) => {
          const baseStyles = {
            "&:hover": {
              boxShadow: "none",
            },
          };

          if (ownerState.variant === "contained" && ownerState.color === "brand") {
            return {
              color: theme.palette.brand.lighter,
              boxShadow: theme.customShadows.z8,
              backgroundColor: theme.palette.brand.darker,
              border: "none",

              "&:hover": {
                boxShadow: "none",
                border: "none",
                backgroundColor: "#000",
              },
            };
          }

          if (ownerState.variant === "outlined" && ownerState.color === "brand" && ownerState.border === "none") {
            return {
              color: theme.palette.brand.dark,
              boxShadow: theme.customShadows.z8,
              backgroundColor: theme.palette.brand.lighter,
              border: "none",

              "&:hover": {
                boxShadow: "none",
                border: "none",
                backgroundColor: theme.palette.brand.lighter,
              },
            };
          }

          if (ownerState.variant === "outlined" && ownerState.color === "brand") {
            return {
              color: theme.palette.brand.dark,
              boxShadow: theme.customShadows.z8,
              backgroundColor: theme.palette.brand.lighter,
              border: `1px solid ${theme.palette.brand.dark}`,

              "&:hover": {
                boxShadow: "none",
                backgroundColor: theme.palette.brand.lighter,
                border: `1px solid ${theme.palette.brand.dark}`,
              },
            };
          }

          return baseStyles;
        },
        sizeLarge: {
          height: 48,
        },
        // contained
        containedInherit: {
          color: theme.palette.grey[800],
          boxShadow: theme.customShadows.z8,
          "&:hover": {
            backgroundColor: theme.palette.grey[400],
          },
        },
        containedPrimary: {
          boxShadow: theme.customShadows.primary,
        },
        containedSecondary: {
          boxShadow: theme.customShadows.secondary,
        },
        containedInfo: {
          boxShadow: theme.customShadows.info,
        },
        containedSuccess: {
          boxShadow: theme.customShadows.success,
        },
        containedWarning: {
          boxShadow: theme.customShadows.warning,

          "&:hover": {
            backgroundColor: alpha(theme.palette.warning.main, 0.85),
          },
        },
        containedError: {
          boxShadow: theme.customShadows.error,
        },
        // outlined
        outlinedInherit: {
          border: `1px solid ${theme.palette.grey[500_32]}`,
          "&:hover": {
            backgroundColor: theme.palette.action.hover,
          },
        },
        textInherit: {
          "&:hover": {
            backgroundColor: theme.palette.action.hover,
          },
        },
      },
    },
  };
}
